import { render, staticRenderFns } from "./BankEdit.vue?vue&type=template&id=e36ed1d6&scoped=true&"
import script from "./BankEdit.vue?vue&type=script&lang=js&"
export * from "./BankEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36ed1d6",
  null
  
)

export default component.exports